import extractDataFromFirebaseCredential from 'lib/extractDataFromFirebaseCredential';

import User from 'types/User';
import { authAndSignInWithProvider, AuthProviders } from 'lib/Auth';

export default async function signInWithGoogle(): Promise<User> {
  const credential = await authAndSignInWithProvider(AuthProviders.Google);
  return extractDataFromFirebaseCredential(credential);
}
